var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticStyle: { "padding-top": "30px" } }, [
    !_vm.is_loaded
      ? _c("div", [_vm._v("\n    The data is loading ...\n  ")])
      : _c("div", [
          _c("div", { staticClass: "page-titles" }, [
            _c(
              "h2",
              {
                staticStyle: {
                  color: "#1C2136",
                  "font-size": "40px",
                  "line-height": "48px",
                  "font-weight": "600",
                },
              },
              [_vm._v("Fact Sheet")]
            ),
            _vm._v(" "),
            _c("h3", [_vm._v(_vm._s(_vm.user.profile.company))]),
            _vm._v(" "),
            _c("ul", { staticClass: "mm-links" }, [
              _c("li", [
                _c(
                  "a",
                  {
                    staticClass: "mm-link-pdf",
                    attrs: { href: "/fs/" + _vm.id + "/pdf" },
                  },
                  [_vm._v("PDF")]
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _c(
                  "a",
                  {
                    staticClass: "mm-link-word",
                    attrs: { href: "/fs/" + _vm.id + "/doc" },
                  },
                  [_vm._v("Word")]
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _c(
                  "a",
                  {
                    staticClass: "mm-link-share",
                    attrs: {
                      target: "_blank",
                      href: "/fs/" + _vm.user.alias + "/share",
                    },
                  },
                  [_vm._v("Share")]
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "pta-factsheet" }, [
            _c("div", { staticClass: "pta-factsheet-left" }, [
              _c("div", { staticClass: "pta-factsheet-box" }, [
                _c("h3", [_vm._v("About the Manager / Sponsor")]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "pta-factsheet-box-content",
                    staticStyle: { "text-align": "center" },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.user.profile.company_description
                            ? _vm.user.profile.company_description
                            : "No general description available."
                        ) +
                        "\n              "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "pta-factsheet-box" }, [
                _c("h3", [
                  _vm._v("Key Differentiators / Track Record Highlights"),
                ]),
                _vm._v(" "),
                _vm.user.profile.track_record_1 ||
                _vm.user.profile.track_record_2 ||
                _vm.user.profile.track_record_3 ||
                _vm.user.profile.track_record_4
                  ? _c("div", { staticClass: "pta-factsheet-box-content" }, [
                      _c("ul", [
                        _vm.user.profile.track_record_1
                          ? _c("li", [
                              _vm._v(_vm._s(_vm.user.profile.track_record_1)),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.user.profile.track_record_2
                          ? _c("li", [
                              _vm._v(_vm._s(_vm.user.profile.track_record_2)),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.user.profile.track_record_3
                          ? _c("li", [
                              _vm._v(_vm._s(_vm.user.profile.track_record_3)),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.user.profile.track_record_4
                          ? _c("li", [
                              _vm._v(_vm._s(_vm.user.profile.track_record_4)),
                            ])
                          : _vm._e(),
                      ]),
                    ])
                  : _c(
                      "div",
                      {
                        staticClass: "pta-factsheet-box-content",
                        staticStyle: { "text-align": "center" },
                      },
                      [
                        _vm._v(
                          "\n              No information available.\n            "
                        ),
                      ]
                    ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "pta-factsheet-right" }, [
              _c("div", { staticClass: "pta-factsheet-box" }, [
                _c("h3", [_vm._v("About the Offering")]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "pta-factsheet-box-content",
                    staticStyle: { "text-align": "center" },
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.user.profile.strategy
                            ? _vm.user.profile.strategy
                            : "No information available."
                        ) +
                        "\n            "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "pta-factsheet-box" }, [
                _c("h3", [_vm._v("Key Terms")]),
                _vm._v(" "),
                _c("div", { staticClass: "pta-factsheet-box-content" }, [
                  _c(
                    "table",
                    {
                      attrs: {
                        cellpadding: "0",
                        cellspacing: "0",
                        width: "100%",
                      },
                    },
                    [
                      _c("tr", [
                        _c("td", [_vm._v("Asset Class")]),
                        _vm._v(" "),
                        _vm.user.profile.fund_type &&
                        _vm.user.profile.fund_type.name
                          ? _c("td", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.user.profile.fund_type.name) +
                                  "\n                "
                              ),
                            ])
                          : _c("td", [_vm._v("-")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("Target Returns")]),
                        _c("td", [
                          _vm._v(
                            "\n                  IRR % " +
                              _vm._s(_vm.user.profile.irr) +
                              " percent IRR / Equity Multiple / MOIC (x) " +
                              _vm._s(_vm.user.profile.moic) +
                              "x (Cash-on-Cash)\n                "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [
                          _vm._v("Structure and Vehicle Domiciliation"),
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.user.profile.inv_struct))]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("Geographical Focus")]),
                        _vm.user.profile.asset_countries.length
                          ? _c(
                              "td",
                              { staticClass: "pta-factsheet-box-content-list" },
                              _vm._l(
                                _vm.user.profile.asset_countries,
                                function (asset_country) {
                                  return _c("span", [
                                    _vm._v(_vm._s(asset_country.name)),
                                  ])
                                }
                              ),
                              0
                            )
                          : _c("td", [_vm._v("-")]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("Target Volume")]),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm.user.profile.total_capital
                                ? _vm.user.profile.total_capital + "m"
                                : "-"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("Holding Period")]),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm.user.profile.holding_period
                                ? _vm.user.profile.holding_period + " year(s)"
                                : "-"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("Minimum Commitment Size")]),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm.user.profile.ticket_size
                                ? _vm.user.profile.ticket_size + "m"
                                : "-"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [
                          _vm._v("Are we a member of any ESG associations?"),
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.user.profile.esg))]),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }